import React from "react";
import { Stack, Typography } from "@mui/material";

import { HubActionDialog } from "../HubActionDialog";

const CloseOpenWorkOrdersDialog = ({
  open,
  workOrders = [],
  onConfirm,
  onClose,
  isClosing = false,
}) => {
  const count = workOrders.length;
  const description = (
    <Stack alignItems="center" gap="6px">
      <Typography variant="body2" textAlign="center">
        {count} work order{count === 1 ? "" : "s"} in this shipment {count === 1 ? "is" : "are"}{" "}
        still open. Close them out so the routing reflects what shipped?
      </Typography>
      <Typography
        variant="caption"
        color="text.secondary"
        textAlign="center"
      >
        {workOrders.slice(0, 6).map((w) => w.workOrder || w.label).join(", ")}
        {count > 6 ? ` … +${count - 6} more` : ""}
      </Typography>
    </Stack>
  );

  return (
    <HubActionDialog
      open={open}
      onClose={onClose}
      action="warning"
      title="Close open work orders?"
      description={description}
      submitLabel={isClosing ? "Closing…" : "Close Work Orders"}
      cancelLabel="Skip"
      handleSubmit={onConfirm}
      disabled={isClosing}
    />
  );
};

export default CloseOpenWorkOrdersDialog;
